import { useCallback as h } from "react";
import { usePLMapboxLayersStore as d } from "./index.es12.js";
import "./index.es99.js";
import "react/jsx-runtime";
import "./index.es4.js";
import "./index.es20.js";
import "@tanstack/react-query";
import "qs";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import "./index.es46.js";
import "./index.es6.js";
import "lodash";
import "@placer-ui/components";
import "react-map-gl";
import "./index.es230.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "use-debounce";
import "./index.es234.js";
import "./index.es131.js";
import "./index.es166.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es204.js";
import "@deck.gl/layers/typed";
import "./index.es235.js";
import "@sentry/react";
import "mapbox-gl";
import "fabric";
import "./index.es170.js";
import "lodash/fp";
import "lodash/throttle";
import "lodash/debounce";
import "queue";
import "geobuckets";
import "./index.es207.js";
import "./index.es59.js";
import "./index.es74.js";
import "./index.es43.js";
import "kdbush";
import "./index.es82.js";
import "./index.es113.js";
import "@deck.gl/extensions/typed";
import "./index.es208.js";
import "./index.es84.js";
import "./index.es23.js";
import "./index.es18.js";
import "./index.es72.js";
import "@deck.gl/geo-layers/typed";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es78.js";
import "@deck.gl/core/typed";
import "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import "./index.es86.js";
import "./index.es209.js";
import "./index.es103.js";
import "react-dom";
import "classnames";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "./index.es214.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es227.js";
import "./index.es228.js";
import "./index.es229.js";
import "./index.es236.js";
import "./index.es137.js";
import "./index.es138.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
import "./index.es203.js";
import "./index.es205.js";
import "./index.es206.js";
const c = {
  data: !0,
  regionType: !0,
  tileVersion: !0
}, F = Object.keys(c), dr = () => {
  const { updateLayerGroup: o } = d((r) => r.actions);
  return h(
    (r) => {
      const { mapId: s, layerId: a, ...n } = r, { fetchFilter: p, visualFilter: m, hasChanges: l } = Object.entries(n).reduce(
        (t, [i, e]) => (F.includes(i) ? (t.fetchFilter[i] = e, t.hasChanges = !0) : (t.visualFilter[i] = e, t.hasChanges = !0), t),
        {
          fetchFilter: {},
          visualFilter: {},
          hasChanges: !1
        }
      );
      if (!l)
        return;
      const u = {
        mapId: s,
        layerGroupId: a,
        ...Object.keys(p).length > 0 && { fetchFilter: p },
        ...Object.keys(m).length > 0 && { visualFilter: m }
      };
      o(u);
    },
    [o]
  );
};
export {
  dr as useUpdateLayer
};
//# sourceMappingURL=index.es188.js.map
